import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PersonalChef = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-sage-light to-beige-light">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/personal-chef-hero.jpg')`,
          backgroundPosition: '50% 10%'}}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-title font-bold text-white mb-6">
              Personal Chef
            </h1>
            <p className="text-lg md:text-2xl font-body text-white max-w-3xl mx-auto">
              Esperienze culinarie su misura per i tuoi eventi privati
            </p>
          </div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-title font-bold text-sage-dark mb-6">
                Cucina Personalizzata Per Ogni Occasione
              </h2>
              <p className="text-lg font-body text-neutral-600 mb-6 leading-relaxed">
                Come <strong>Personal Chef</strong> puoi contattarmi per eventi privati o aziendali, cene intime e occasioni speciali in famiglia o tra amici. Ogni menu è studiato su misura per soddisfare i gusti e le esigenze specifiche.
              </p>
              <p className="text-lg font-body text-neutral-600 mb-8 leading-relaxed">
                Dalla progettazione del menu, alla preparazione fino al servizio: ogni dettaglio è curato per garantire un'esperienza piacevole e appagante. Mi occuperò io di tutto, tu penserai solo a goderti l’evento.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/contatti"
                  className="bg-sage-dark hover:bg-sage-medium text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 text-center"
                >
                  Richiedi Preventivo
                </Link>
                <a 
                  href="https://wa.me/393458279163?text=Ciao, ho visto il tuo sito ACQUOLINA e vorrei maggiori informazioni sui tuoi servizi."
                  className="border-2 border-sage-dark hover:bg-sage-dark hover:text-white text-sage-dark px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Scrivimi su WhatsApp
                </a>
              </div>
            </div>
            <div>
              <div 
                className="rounded-3xl shadow-2xl h-96 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1518619745898-93e765966dcd')`,
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Types - Riorganizzato con 4 servizi in 2x2 */}
      <section className="py-20 bg-beige-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Servizi Personalizzati
            </h2>
            <p className="text-xl font-body text-neutral-600 max-w-3xl mx-auto">
              Ogni evento è unico, così come il servizio che offro
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Cene Private */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="mb-6">
                <svg className="w-16 h-16 text-sage-dark mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                Cene Private
              </h3>
              <p className="font-body text-neutral-600 leading-relaxed">
                Cene intime per piccoli gruppi. Menu personalizzato, servizio a domicilio e atmosfera curata per momenti speciali da ricordare.
              </p>
            </div>

            {/* Eventi Aziendali */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="mb-6">
                <svg className="w-16 h-16 text-sage-dark mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                Eventi Aziendali
              </h3>
              <p className="font-body text-neutral-600 leading-relaxed">
                Catering di qualità per meeting, presentazioni ed eventi. Soluzioni flessibili per ogni tipo di esigenza aziendale.
              </p>
            </div>

            {/* Celebrazioni */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="mb-6">
                <svg className="w-16 h-16 text-sage-dark mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"/>
                </svg>
              </div>
              <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                Celebrazioni
              </h3>
              <p className="font-body text-neutral-600 leading-relaxed">
                Compleanni, lauree, anniversari e feste private. Tu scegli la location e io penso a tutto il resto. 
              </p>
            </div>

            {/* Cooking Classes */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="mb-6">
                <svg className="w-16 h-16 text-sage-dark mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                </svg>
              </div>
              <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                Lezioni di Cucina
              </h3>
              <p className="font-body text-neutral-600 leading-relaxed">
                Corsi personalizzati singoli o in piccolo gruppo per imparare nuove ricette che ti permettano di ottimizzare il tuo tempo in cucina, senza rinunciare al gusto. Condivido segreti e passioni della cucina italiana.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Come Lavoro
            </h2>
            <p className="text-xl font-body text-neutral-600 max-w-3xl mx-auto">
              Un approccio professionale per garantire il successo del tuo evento
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Step 1 */}
            <div className="text-center">
              <div className="bg-sage-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-sage-dark">1</span>
              </div>
              <h3 className="text-xl font-title font-bold text-sage-dark mb-4">Consultazione</h3>
              <p className="font-body text-neutral-600">
                Incontro o chiamata preliminare per comprendere le tue esigenze, preferenze e il tipo di evento che ti aspetti
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center">
              <div className="bg-sage-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-sage-dark">2</span>
              </div>
              <h3 className="text-xl font-title font-bold text-sage-dark mb-4">Progettazione</h3>
              <p className="font-body text-neutral-600">
                Creazione di un menu personalizzato in base ai gusti, esigenze e allergie/intolleranze
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="bg-sage-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-sage-dark">3</span>
              </div>
              <h3 className="text-xl font-title font-bold text-sage-dark mb-4">Preparazione</h3>
              <p className="font-body text-neutral-600">
                Preparazione accurata di ogni piatto con ingredienti freschi e di prima qualità
              </p>
            </div>

            {/* Step 4 */}
            <div className="text-center">
              <div className="bg-sage-light rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-sage-dark">4</span>
              </div>
              <h3 className="text-xl font-title font-bold text-sage-dark mb-4">Servizio</h3>
              <p className="font-body text-neutral-600">
                Mise en place, servizio al tavolo, pulizia e tutti i servizi concordati presso la tua location, con professionalità e discrezione
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Placeholder */}
      <section className="py-20 bg-beige-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Cosa Dicono i Clienti
            </h2>
            <p className="text-xl font-body text-neutral-600 max-w-3xl mx-auto mb-8">
              Testimonianze di chi ha vissuto l'esperienza ACQUOLINA
            </p>
            <div className="bg-white rounded-3xl p-12 shadow-xl">
              <div className="border-2 border-dashed border-sage-light rounded-xl p-8 text-center">
                <svg className="w-16 h-16 text-sage-medium mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                <h3 className="text-xl font-title font-semibold text-sage-dark mb-2">
                  Recensioni dei Clienti
                </h3>
                <p className="font-body text-neutral-600">
                  
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Placeholder Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Eventi
            </h2>
            <p className="text-xl font-body text-neutral-600 max-w-3xl mx-auto mb-8">
              Alcuni momenti speciali
            </p>
            <div className="bg-beige-light rounded-3xl p-12 shadow-xl">
              <div className="border-2 border-dashed border-sage-light rounded-xl p-8 text-center">
                <svg className="w-16 h-16 text-sage-medium mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <h3 className="text-xl font-title font-semibold text-sage-dark mb-2">
                  Foto Professionali in Arrivo
                </h3>
                <p className="font-body text-neutral-600">
                  
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-sage-dark text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-5xl font-title font-bold mb-6">
            Pronto per la Tua Esperienza?
          </h2>
          <p className="text-xl font-body mb-8 opacity-90">
            Contattami per discutere del tuo evento e creare insieme un'esperienza 
            culinaria indimenticabile.
          </p>
          <div className="flex justify-center">
            <a 
              href="https://wa.me/393458279163?text=Ciao, ho visto il tuo sito ACQUOLINA e vorrei maggiori informazioni sui tuoi servizi."
              className="bg-white text-sage-dark hover:bg-beige-light px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
              target="_blank"
              rel="noopener noreferrer"
            >
              Scrivimi su WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PersonalChef;